import React, { useState } from 'react';

import Dim from 'web/components/common/modal/common/Dim';
import Links from 'web/components/common/modal/common/Links';
import * as input from 'web/components/common/modal/common/input';
import Logo from 'web/components/common/modal/common/Logo';
import CloseBtn from 'web/components/common/modal/common/CloseBtn';

import classNames from 'classnames/bind';
import styles from './Login.scss';
const cx = classNames.bind(styles);

const Login = ({
  username,
  password,
  handleChange,
  handleSubmit,
  handlePopup,
  error = {},
}) => {
  const [chk, setChk] = useState(false);
  //연속클릭 방지 disabled
  const submitChk = e => {
    handleSubmit(e);
    setChk(true);
    setTimeout(() => {
      setChk(false);
    }, 1000);
  };

  return (
    <Dim>
      <div
        className={cx('Login')}
        onClick={e => e.stopPropagation()}
        onMouseDown={e => e.stopPropagation()}
      >
        <Logo title={'로그인'} />
        <form
          onSubmit={e => {
            e.preventDefault();
            handleSubmit(e);
          }}
        >
          <input.Text
            key={`join-username`}
            type={'text'}
            name={'username'}
            value={username}
            error={error.status && error.type === 'username' ? error.desc : ''}
            validation={
              error.status && error.type === 'username' ? false : null
            }
            onChange={handleChange}
            placeholder={`이메일`}
          />
          <input.Text
            key={`join-password`}
            type={'password'}
            name={'password'}
            value={password}
            error={error.status && error.type === 'password' ? error.desc : ''}
            validation={
              error.status && error.type === 'password' ? false : null
            }
            onChange={handleChange}
            placeholder={`비밀번호 (8자 이상)`}
          />

          <div className="buttons">
            <input.Button
              type="submit"
              onClick={e => submitChk(e)}
              disabled={chk ? true : false}
            >
              로그인
            </input.Button>
          </div>
        </form>

        <Links
          links={[
            {
              id: 0,
              title: '이메일을 잊어버리셨나요?',
              onClick: handlePopup.findEmail,
            },
            {
              id: 1,
              title: '비밀번호를 잊어버리셨나요?',
              onClick: handlePopup.findPassword,
            },
          ]}
        />
        {/* <div className="links">
          <button type="button" onClick={handlePopup.findEmail}>
            이메일을 잊어버리셨나요?
          </button>
          <button type="button" onClick={handlePopup.findPassword}>
            비밀번호를 잊어버리셨나요?
          </button>
        </div> */}

        <CloseBtn onClick={handlePopup.close} className={['btn-close']} />
      </div>
    </Dim>
  );
};

export default Login;
